import { AxiosResponse } from 'axios';
import Store from '@/store/index';
import Customer from '@/models/Customer';

export default class CustomerService {
    public async LoadCustomer(id: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.companyLoad;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?id=${id}`);

            let returnValue: Customer = new Customer();
            returnValue.Id = response.data.Id;
            returnValue.Name = response.data.Name;
            returnValue.Active = response.data.Active;
            returnValue.DateUpdated = response.data.DateUpdated;

            return { Error: false, Data: returnValue };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async AddCustomer(customerInfo: Customer) {
        const postData = {
            Name: customerInfo.Name,
            Active: customerInfo.Active
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.companyAdd;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, postData);
            return { Error: false, Data: response.data.id };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async UpdateCustomer(customerInfo: Customer) {
        const postData = {
            Id: customerInfo.Id,
            Name: customerInfo.Name,
            Active: customerInfo.Active
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.companyUpdate;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.put(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async DeleteCustomer(id: number) {
        const postData = {
            Id: id
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.companyDelete;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.delete(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async GetScreensForUser(userId: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.companyGetScreensForUser;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?userId=${userId}`);

            Store.commit('setCustomerScreens', response.data);

            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }
}
